export default __webpack_public_path__ + "static/media/food-menu2.73bd2768.jpeg";